module.exports = __webpack_public_path__ + "img/email.330466bc.svg";